export const DLayoutClearType = wcardinal.ui.DLayoutClearType;